import { observer } from 'mobx-react-lite';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { PageContainer } from '@flixbus/honeycomb-react';

import { authStore } from 'auth/authStore';
import AppHeader from 'common/AppHeader';
import AuthGuard from 'common/AuthGuard';
import { ActiveElementsProvider } from 'global/ActiveElements/ActiveElementsProvider';
import { RootActiveElementsHost } from 'global/ActiveElements/RootActiveElementsHost';
import Buddy from 'global/Buddy';
import AssistantSkeleton from 'pages/Assistant/AssistantSkeleton';
import { ASSISTANT_PATH } from 'pages/Assistant/const';

const NavbarWrapper = observer(() => {
	const { pathname } = useLocation();

	const isAssistantPage = pathname.startsWith(ASSISTANT_PATH);

	const content =
		isAssistantPage && authStore.isAuthStatusLoading ? (
			<AssistantSkeleton />
		) : (
			<AuthGuard>
				<Outlet />
				<RootActiveElementsHost />
			</AuthGuard>
		);

	return (
		<>
			<AppHeader />
			<PageContainer hasFixedHeader>
				<ActiveElementsProvider>
					<main className="main-container">{content}</main>
				</ActiveElementsProvider>
			</PageContainer>
			{!isAssistantPage && <Buddy />}
		</>
	);
});

export default NavbarWrapper;
